import React, { forwardRef } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Badge } from './Badge';
import { Lock, FileText, Zap } from 'lucide-react';
import { trackAddToCart } from '../lib/meta-pixel';
export const PricingSection = forwardRef<HTMLElement>((props, ref) => {
  return <section ref={ref} className="py-24 bg-stone-900 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-173">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-600/10 blur-[120px] rounded-full pointer-events-none" data-id="element-174" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-175">
        <FadeIn data-id="element-176">
          <div className="bg-stone-950 border border-amber-500/30 rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-177">
            {/* Top accent line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 via-orange-400 to-amber-500" data-id="element-178" />

            <Badge variant="secondary" className="bg-amber-500/20 text-amber-300 hover:bg-amber-500/30 mb-4 px-4 py-1.5 text-sm border-amber-500/30" data-id="element-179">
              Acceso Inmediato
            </Badge>

            <div className="inline-flex items-center gap-2 mb-8" data-id="element-180">
              <Badge className="bg-rose-500/20 text-rose-300 border-rose-500/30 hover:bg-rose-500/30 px-3 py-1 text-xs font-bold uppercase tracking-wider" data-id="element-181">
                -62% Descuento
              </Badge>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-182">
              Recupera tus noches
            </h2>

            <p className="text-lg md:text-xl text-stone-300 mb-10 max-w-xl mx-auto" data-id="element-183">
              Recupera tus noches y tu energía por menos de lo que cuesta un
              café. Obtén acceso inmediato al método que convertirá tu almohada
              en un lugar de paz, no de oficina.
            </p>

            <div className="flex flex-col items-center justify-center gap-1 mb-10" data-id="element-184">
              <div className="flex items-center gap-3" data-id="element-185">
                <span className="text-stone-500 text-2xl line-through decoration-rose-500/70 decoration-2" data-id="element-186">
                  $17
                </span>
                <span className="text-5xl md:text-7xl font-black text-white" data-id="element-187">
                  $6<span className="text-4xl md:text-5xl" data-id="element-188">,39</span>
                </span>
                <span className="text-stone-400 text-xl" data-id="element-189">USD</span>
              </div>
              <p className="text-amber-400 text-sm font-medium mt-2" data-id="element-190">
                Ahorras $10,61 con esta oferta especial
              </p>
            </div>

            <a href="https://www.nachogerberg.com/cart/42710498476103:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} data-id="element-191">
              <Button size="lg" className="w-full sm:w-auto bg-amber-600 hover:bg-amber-700 text-white text-lg px-12 py-7 h-auto rounded-full shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] transition-all hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.7)] hover:scale-105 mb-8" data-id="element-192">
                DESCARGAR EL PROTOCOLO AHORA
              </Button>
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-stone-400" data-id="element-193">
              <div className="flex items-center gap-2" data-id="element-194">
                <Lock className="w-4 h-4" data-id="element-195" />
                <span data-id="element-196">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-197">
                <FileText className="w-4 h-4" data-id="element-198" />
                <span data-id="element-199">PDF Instantáneo</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-200">
                <Zap className="w-4 h-4" data-id="element-201" />
                <span data-id="element-202">Aplica Hoy Mismo</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
});
PricingSection.displayName = 'PricingSection';